import './App.css';
import HexConversion from './HexConversion';

function App() {
  return (
    <div className="App">
      <HexConversion />
    </div>
  );
}

export default App;
